import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord } from 'services/TransportProviderUserService'

export const getData = createAsyncThunk(
    'transportProviderUser/data/getData',
    async (data) => {
        const response = await getApiData(data)
        return response.data
    },
)

export const getRecord = createAsyncThunk(
    'transportProviderUser/data/getRecord',
    async (id) => {
        const response = await getApiRecord(id)
        const data = {
            ...response.data,
            first_name: response.data?.user?.first_name,
            last_name: response.data?.user?.last_name,
            email: response.data.user?.email,
            title: response.data.title,
            company: parseInt(response.data?.assignment?.company_id),
            client: response.data?.assignment?.client_id,
            transport_provider: response.data.assignment.transport_provider,
            service: response.data.assignment.service,
        }
        return data
    },
)

const recordData = {
    company: '',
    client: '',
    transport_provider: '',
    service: '',
    first_name: '',
    last_name: '',
    email: '',
    title: '',
}

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    selectedTab: '',
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'transportProviderUser/data',
    initialState: {
        loading: false,
        view: recordData,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getData.pending, (state) => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, (state) => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, (state) => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, (state) => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setTableData } = dataSlice.actions

export default dataSlice.reducer
